import {useStaticQuery, graphql} from 'gatsby'

export const getAllTags = graphql`
  query AllTags {
    allMdx {
      group(field: frontmatter___blogTags) {
        fieldValue
      }
    }
  }
`

const useBlogTagsQuery = () => {
  const {allMdx} = useStaticQuery(getAllTags)

  const tags = allMdx.group.map(tag => tag.fieldValue)

  return tags
}

export {useBlogTagsQuery}
